export const traits = [
    "Kind",
    "Loving",
    "Wise",
    "Honest",
    "Generous",
    "Humorous",
    "Compassionate",
    "Patient",
    "Adventurous",
    "Gentle",
    "Loyal",
    "Creative",
  ];